import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'


const notState = {
    locationRef: null,
}
// initial state
const state = {
  locations: [],
  uid: null,
  group: null, // which group in contributors
  name: null,
  // contributorPrefix: null,
  activeLocation: null, // Which location are we actively edit or viewing?
}

// getters
const getters = {
}

// actions
const actions = {

  async loadUid ({commit, dispatch}, {uid}) {

    // Don't reload everything if we don't need to.
    if (state.uid === uid) {
        // We're already there!
        return
    }

    // First commit the uid
    commit('setUID', uid)
    console.log("LoadUID: "+uid)
    if (!uid || uid == null) {
        console.error("Missing UID in loadUID")
        return
    }

    // Get my group also
    let contribRef = firebase.database().ref('contributors').child(uid)

    let snap = await contribRef.once("value")
    let group = snap.val()
    console.log("My group is: "+group)
    commit('setGroup', group)


    // Now lookup the contributor prefix for their boxes
    // const prefix = "NB"
    // commit('setContributorPrefix', prefix)

    const p1 = dispatch('watchLocations')
    // const p2 = dispatch('getUserInfo')
    // const p3 = dispatch('watchItems', uid)
    // const p4 = dispatch('cart/loadCart', {}, {root: true})

    return Promise.all([p1]).catch((err) => {
      console.log('ERROR loading UID')
      throw err
    })
  },



  watchLocations ({commit}) {
    // TODO: Do I need to stop watching a previous "WATCH" here first?
    // Kill the previous query
    if (notState.locationRef != null) {
      notState.locationRef.off('value')
      notState.locationRef = null
    }

    // Load the data
    let locationRef = firebase.database().ref('static_locations_info').orderByChild('group').equalTo(state.group)

    locationRef.on('value', (querySnapshot) => {
      const docs = []
      querySnapshot.forEach(function (doc) {
        // console.log('Item :' + doc.id, ' => ', doc.data())
        const docData = doc.val()
        docData.firebaseId = doc.key
        docs.push(docData)
      })

      notState.locationRef = locationRef
      // commit('setLocationRef', locationRef)
      commit('storeLocations', {locations: docs})
    }, (err) => {
      console.log('ERROR watchLocations:' + err)
      commit('storeLocations', {items: []})
    })

  }
}

// mutations
const mutations = {

  setLocationRef (state, locationRef) {
    state.locationRef = locationRef
  },

  setUID (state, uid) {
    state.uid = uid
  },
  setGroup (state, group) {
    state.group = group
  },

  setContributorPrefix (state, prefix) {
    state.contributorPrefix = prefix
  },

  storeLocations (state, {locations}) {
      state.locations = locations
  },
  setActiveLocation (state, location) {
      state.activeLocation = location
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
